import { ActorSubclass } from "@dfinity/agent";
import { getStoreWalletUnlocked } from "store/auth/hooks";
import { type CreateActorArgs, ConnectorAbstract, Connector, WalletConnectorConfig } from "./connectors";

export class InfinityConnector implements ConnectorAbstract {
  private config: {
    whitelist: Array<string>;
    providerUrl: string;
    host: string;
    dev: boolean;
  };

  private principal?: string;

  public type = Connector.INFINITY;

  public get getPrincipal() {
    return this.principal;
  }

  constructor(config: WalletConnectorConfig) {
    this.config = {
      whitelist: config.whitelist,
      host: config.host,
      providerUrl: "",
      dev: false,
    };
  }

  async init() {
    return true;
  }

  async createActor<Service>({
    canisterId,
    interfaceFactory,
  }: CreateActorArgs): Promise<ActorSubclass<Service> | undefined> {
    return await window.ic.infinityWallet.createActor({ canisterId, interfaceFactory });
  }

  async isConnected() {
    const isUnLocked = getStoreWalletUnlocked();

    if (typeof isUnLocked === "boolean" && !isUnLocked) {
      return false;
    }

    if (window.ic.infinityWallet) {
      return await window.ic.infinityWallet.isConnected();
    }

    return false;
  }

  async connect() {
    if (await this.isConnected()) {
      this.principal = (await window.ic.infinityWallet.getPrincipal()).toString();
    } else {
      // disconnect first
      await window.ic.infinityWallet.disconnect();
      await window.ic.infinityWallet.requestConnect({ whitelist: this.config.whitelist });

      this.principal = (await window.ic.infinityWallet.getPrincipal()).toString();
    }

    return true;
  }

  async disconnect() {
    await window.ic.infinityWallet.disconnect();
  }

  async expired() {
    return false;
  }
}

export const InfinitySwapWallet = {
  connector: InfinityConnector,
  id: "infinity",
  type: Connector.INFINITY,
};
